/**
 * Site JS
 */

import 'slick-carousel';
import './global';
import './template-tags';
import './templates';
import './blocks';
import './woocommerce';
